import { LuFileHeart } from "react-icons/lu";

const MSManual = () => {
  return (
    <div className="py-12 bg-gray-100 flex flex-col justify-center">
      <div className="max-w-md mx-auto px-4 text-center">
        <h1 className="text-3xl font-bold text-gray-700 mb-4">How It Works</h1>
        <p className="text-sm text-gray-600 mb-8">
          User guide on how to use MVIP
        </p>
        <div className="flex gap-5">
          <a
            href="/manuals/MVIP_MS.pdf"
            target="_blank"
            className="bg-white p-12 shadow-sm border rounded-sm text-center"
          >
            <div className="text-[30px] text-gray-600 justify-center flex">
              <LuFileHeart />
            </div>
            <p className="text-sm mt-5">
              User manual <br />
              for Marine Superintendents
            </p>
          </a>

          <a
            href="/manuals/MVIP_MSTAB.pdf"
            target="_blank"
            className="bg-white p-12 shadow-sm border rounded-sm text-center"
          >
            <div className="text-[30px] text-gray-600 justify-center flex">
              <LuFileHeart />
            </div>
            <p className="text-sm mt-5">
              User manual Tablets
              <br />
              for Marine Superintendents
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MSManual;
